<template>
  <!-- 头部 -->
  <div class="head van-hairline--bottom">
    <img
      :src="logo"
      alt="logo"
      srcset=""
      class="logo"
      @click="goPage({ url: '/mb_index' })"
    />
    <div class="icon-box">
      <i class="iconfont-icon icon-user2" @click="goPage({ url: '/mb_personCenter' })"></i>
      <i class="iconfont-icon icon-daohang1" @click="openNav"></i>
    </div>
    <div class="nav-content" v-if="isShowNav" @click="isShowNav = false">
      <div class="nav-box" @click.stop>
        <div
          class="nav-list border-bottom"
          v-for="(item, index) in navList"
          :key="index"
          @click="goPage(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/mobile/logo.png";

export default {
  name: "headerView",
  data() {
    return {
      logo,
      isShowNav: false,
      navList: [
        {
          name: "首页",
          url: "/mb_index"
        },
        {
          name: "远程教育",
          url: "/mb_remoteEducation"
        },
        {
          name: "能力培训",
          url: "/mb_capacityTrain"
        },
        {
          name: "考试报名",
          url: "/mb_examinationRegist"
        },
        {
          name: "柏瑞康书斋",
          url: "/mb_studyRoom"
        },
        {
          name: "学校风采",
          url: "/mb_schoolStyle"
        },
        {
          name: "个人中心",
          url: "/mb_personCenter"
        }
      ]
    };
  },
  methods: {
    openNav() {
      this.isShowNav = !this.isShowNav;
    },
    goPage(item) {
      this.$router.push({ path: item.url });
      this.isShowNav = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.head {
  position: fixed;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 30px;
  height: 96px;
  background-color: #ffffff;
  .logo {
    width: 206px;
    height: 46px;
  }
  .iconfont-icon {
    font-size: 48px;
    color: #4d4d4d;
  }
  .icon-user2 {
    margin-right: 18px;
  }
  .nav-content {
    position: absolute;
    z-index: 100;
    top: 96px;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }
  .nav-list {
    font-size: 32px;
    color: #4d4d4d;
    line-height: 114px;
    &::before {
      border-color: #cccccc;
    }
    &:last-child {
      &::before {
        border-color: transparent;
      }
    }
  }
  .nav-box {
    padding: 0 30px;
    background-color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/headerNav.vue